import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { EChartOption, ECharts } from 'echarts';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from '../../service/common.service';
import { BasicBarLineService } from './basic-bar-line.service';
import { ChartOptionService } from '../../service/chart-option.service';
import { ChartResizeService } from '../../service/chart-resize.service';
import { valueFunctionProp } from 'ng-zorro-antd';
@Component({
  selector: 'bcac-basic-bar-line',
  templateUrl: './basic-bar-line.component.html',
  styleUrls: ['./basic-bar-line.component.scss']
})
export class BasicBarLineComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private basicBarLineService: BasicBarLineService,
    private chartOptionService: ChartOptionService,
    private chartResizeService: ChartResizeService
  ) { }

  chartTitle = {
    show: true,
    label: "图表标题"
  };


  // 布局设置
  // cardpadding
  cardPadding = "1rem";
  cardBgColor = "#fff";
  chartTitleColor = '';

  // eachrt图表元素
  chartBackgroundColor: string = "#fff";
  chartColors: string[] = this.chartOptionService.getChartColors("default");
  chartTitles = this.chartOptionService.getChartTitle();
  chartLegend = this.chartOptionService.getChartLegend();
  chartGrid: EChartOption.Grid = this.commonService.changeFontSize().interval;
  chartxAxis: EChartOption.XAxis[] = this.basicBarLineService.getChartxAxis();
  chartyAxis: EChartOption.YAxis[] = this.chartOptionService.getChartyAxis(2);
  chartTextStyle: EChartOption.TextStyle = this.chartOptionService.getTextStyle();
  lineChartSeries: EChartOption.Series = this.basicBarLineService.getDefaultLineSeries();
  barChartSeries: EChartOption.Series = this.basicBarLineService.getDefaultBarSeries();
  chartTooltip: EChartOption.Tooltip = this.basicBarLineService.getDefaultTooltip();
  chartSeriesList: EChartOption.Series[] = [];

  chartOption = {
    backgroundColor: this.chartBackgroundColor,
    title: this.chartTitles,
    legend: this.chartLegend,
    grid: this.chartGrid,
    xAxis: this.chartxAxis,
    yAxis: this.chartyAxis,
    series: this.chartSeriesList,
    tooltip: this.chartTooltip,
    color: this.chartColors,
    textStyle: this.chartTextStyle
  };

  initOpts = this.chartOptionService.getInitOpts();
  optionInit: ECharts;
  onOptionInit(ec) {
    this.optionInit = ec;
  }

  options;
  // echart配置项
  initEchart() {
    this.options = this.chartOption;
  }

  updateOption() {
    if (this.optionInit) {
      this.optionInit.setOption(this.options, true);
    }
  }

  //接口区
  @Input()
  set bcacDarkMode(darkMode: boolean) {
    this.basicBarLineService.changeChartTitleDark(this, darkMode);
    this.basicBarLineService.chartBackgroundColorDarkMode(this.chartOption);
    this.basicBarLineService.xAxisDarkMode(this.chartxAxis);
    this.basicBarLineService.yAxisDarkMode(this.chartyAxis);
    this.basicBarLineService.colorsDarkMode(this.chartColors);
    this.basicBarLineService.legendDarkMode(this.chartLegend);
    this.basicBarLineService.seriesDarkMode(this.lineChartSeries);
    this.basicBarLineService.seriesDarkMode(this.barChartSeries);
  }
  // 小边距模式
  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.basicBarLineService.setSmallModeGrid(this.chartGrid);
    }
  }
  // 图例位置印象grid，所以图例位置接口必须放在smallMode接口后面
  legendPosition = "right";
  @Input()
  set bcacLegendPosition(legendPosition: string) {
    this.legendPosition = legendPosition;
    this.basicBarLineService.setLegendPosition(this.chartGrid, this.chartLegend, legendPosition);
  }
  // title开关
  @Input()
  set bcacTitleSwitch(titleSwitch: boolean) {
    this.chartTitle.show = titleSwitch;
  }
  // title文字
  @Input()
  set bcacTitle(title: string) {
    this.chartTitle.label = title;
  }
  // x轴name
  @Input()
  set bcacXaxisName(xAxisname: string) {
    this.basicBarLineService.setXaxisName(this.chartxAxis, xAxisname);
  }
  // y轴name
  @Input()
  set bcacYaxisName(yAxisNames: string[]) {
    this.basicBarLineService.setYaxisName(this.chartyAxis, yAxisNames);
  }
  // y轴name与坐标轴的距离
  @Input()
  set bcacYnameGap(yNameGap: number) {
    this.basicBarLineService.setYnameGap(this.chartyAxis, yNameGap);
  }
  // 颜色
  @Input()
  set bcacColors(colorList: string[]) {
    this.basicBarLineService.chartColorsChange(this.chartColors, colorList);
  }
  // 折线区域开关
  @Input()
  set bcacAreaStyleSwitch(areaStyleSwitch: boolean) {
    if (areaStyleSwitch) {
      this.lineChartSeries['areaStyle'] = {};
    }
  }
  // 系列label显示开关 （柱状图上的值）
  @Input()
  set bcacSeriesLabelSwitch(seriesLabelSwitch: boolean) {
    if (seriesLabelSwitch == false) {
      this.barChartSeries['label']['show'] = false;
    }
  }

  legendDataList;
  @Input()
  set bcacChartData(chartData: any) {
    let legendDataList = [];
    if(chartData && chartData.hasOwnProperty('seriesName')) {
      chartData.seriesName.forEach(e => {
        legendDataList.push(
          {
            label: e.name,
            value: e.name,
            checked: true
          }
        );
      });
    }
    this.legendDataList = legendDataList;
    this.basicBarLineService.buildSeries(chartData, this.chartSeriesList, this.chartxAxis, this.lineChartSeries, this.barChartSeries);
    this.updateOption();
  }

  legendChange(e) {
    this.basicBarLineService.topLegendChange(e, this.optionInit);
  }

  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    this.dataSourceSelectData = value;
  }

  @Input()
  set bcacYAxisMin(min: number[]) {
    this.basicBarLineService.setYAxisMin(this.chartyAxis, min)
  }

  @Input()
  set bcacYAxisMax(max: number[]) {
    this.basicBarLineService.setYAxisMax(this.chartyAxis, max)
  }

  @Input()
  set bcacYAxisInterval(interval: number[]) {
    this.basicBarLineService.setYAxisInterval(this.chartyAxis, interval)
  }

  @Input()
  set bcacYAxisSplitLine(splitLine: boolean) {
    this.basicBarLineService.setYAxisSplitLine(this.chartyAxis, splitLine);
  }

  @Input()
  set bcacUnit(units: string[]) {
    this.basicBarLineService.setUnit(this.chartTooltip, units);
    this.updateOption();
  }

  @Output()
  bcacDataSourceSelectEmit = new EventEmitter<any>();
  dataSourceChange(e: any) {
    this.bcacDataSourceSelectEmit.emit(e);
  }

  // X轴刻度间隔
  intervalDatas = [];
  intervalSelectedData;
  intervalSelectedDataChange(e: any) {
    // 跟新图表interval
    this.basicBarLineService.setInterval(this.chartOption, e);
    this.updateOption();
  }

  axisScaleChange(e: any) {
    this.basicBarLineService.setInterval(this.chartOption, e);
    this.updateOption();
  }

  @Input()
  set bcacInterValDatas(value: any[]) {
    this.intervalDatas = value;
  }

  // 加载等待
  _bcacChartLoading: boolean = false
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }
  test() {
  }
  ngOnInit() {
    this.initEchart();
    this.updateOption();
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeService.autoResizeAdapt(this.optionInit, this.options);
    })
  }
}
